import React from "react";

import { List, ListItemButton, ListItemIcon, ListItemText, Stack } from "@mui/material";
import { FILE_STATUS_OPTIONS, getFileStatusConfig } from "components/File-status/status-options";
import { FileRepoStatus } from "store/types";

/** Re-exported for existing consumers (Deal-workspace MetadataTable). */
export const getStatusConfig = getFileStatusConfig;

interface Props {
  currentStatus: string | null;
  onSubmit: (result: { status: FileRepoStatus }) => void;
  onCancel: () => void;
}

export const OperationsStatusPrompt: React.FC<Props> = ({ currentStatus, onSubmit }) => (
  <Stack sx={{ minWidth: 240, py: "8px" }}>
    <List disablePadding>
      {FILE_STATUS_OPTIONS.map(({ value, label, iconColor, Icon }) => (
        <ListItemButton
          key={value}
          selected={currentStatus === value}
          onClick={() => onSubmit({ status: value })}
          sx={{
            py: "6px",
            px: "16px",
            "&.Mui-selected": { bgcolor: "#edf1f9" },
            "&:hover": { bgcolor: "#f6f8fc" }
          }}
        >
          <ListItemIcon sx={{ minWidth: 28 }}>
            <Icon sx={{ fontSize: 16, color: iconColor }} />
          </ListItemIcon>
          <ListItemText primary={label} sx={{ "& .MuiTypography-root": { fontSize: "14px", color: "#071f35" } }} />
        </ListItemButton>
      ))}
    </List>
  </Stack>
);
